import { Provider } from '@angular/core';

import { DocumentsRepositoryImpl } from '@app/data/repositories/ptrab/documents/documents.repository';
import { DOCUMENTS_REPOSITORY } from '@app/domain/repositories/ptrab/documents/documents.repository.contract';

export const documentsRepositoryProvider: Provider = {
  provide: DOCUMENTS_REPOSITORY,
  useClass: DocumentsRepositoryImpl
};
